module.exports = __webpack_public_path__ + "static/media/no-deals-researching.eab0107e.png";